import React from 'react';
import { X, FileText, Calendar } from 'lucide-react';
import { TERMS_VERSION_LABEL } from '../../lib/config/termsVersion';
import { TERMS_CONTENT_HTML } from '../../lib/config/termsContentHtml';

interface TermsOfServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TermsOfServiceModal({ isOpen, onClose }: TermsOfServiceModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-xl max-w-5xl w-full max-h-[95vh] overflow-hidden my-4 flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-white shrink-0">
          <div className="flex items-center space-x-3">
            <FileText className="w-6 h-6 text-[#1F2937]" />
            <h2 className="text-xl font-bold text-gray-900">Termini e Condizioni di Servizio</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Chiudi"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-1 min-h-0">
          <div className="prose prose-gray max-w-none">
            <div className="bg-[#1F2937]/10 border border-[#1F2937]/20 rounded-lg p-4 mb-6">
              <div className="flex items-center space-x-2 mb-2">
                <Calendar className="w-5 h-5 text-[#1F2937]" />
                <span className="font-semibold text-[#1F2937]">Ultimo aggiornamento: {TERMS_VERSION_LABEL}</span>
              </div>
              <p className="text-gray-700 text-sm mb-2">
                Questi Termini e Condizioni di Servizio ("Termini") disciplinano l'accesso e l'utilizzo della piattaforma software Flusia fornita da Obly Srls.
              </p>
              <p className="text-gray-700 text-sm font-semibold">
                Si prega di leggere attentamente questi Termini prima di utilizzare il Servizio.
              </p>
            </div>

            {/* Testo legale integrale: sorgente unica generata in
                src/lib/config/termsContentHtml.ts — non duplicare qui. */}
            <div dangerouslySetInnerHTML={{ __html: TERMS_CONTENT_HTML }} />
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between p-6 border-t border-gray-200 bg-gray-50 shrink-0">
          <span className="text-xs text-gray-600">Ultimo aggiornamento: {TERMS_VERSION_LABEL}</span>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#1F2937] text-white rounded-lg hover:bg-[#111827] transition-colors text-sm font-medium"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
}
